import * as React from 'react';
import { Image, SourceType } from './image';
import ImageResource from '../utilities/imageResource';

export interface CatalogImageProps {
	image: ImageResource;
	width?: number;
	height?: number;
}

const CatalogImage: React.FunctionComponent<CatalogImageProps> = ({ image, width, height }) => {
	return <Image width={width} height={height} image={image} sourceType={SourceType.catalog} />;
};

export default CatalogImage;
